import { render, staticRenderFns } from "./ApprovalRequestModalContent.vue?vue&type=template&id=52c95431&"
import script from "./ApprovalRequestModalContent.vue?vue&type=script&lang=js&"
export * from "./ApprovalRequestModalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports